{
  "adultMode": false,
  "ageGate": true,
  "handicapAllowed": true,
  "sensitiveFilter": true,
  "danmakuPerMinute": 20,
  "skipDailyLimit": 3,
  "announcement": "",
  "announcementEnabled": true
}
